import {
  Button,
  Image,
  Row,
  Drawer,
  Badge,
  Input,
  Dropdown,
  Avatar,
} from "antd";
import { Header } from "antd/es/layout/layout";
import { useState } from "react";
import {
  MenuOutlined,
  CloseSquareOutlined,
  DownOutlined,
  ShoppingCartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "wouter";
import { logout } from "../../../redux/reducers/authSlice";
import { DEALER, SALESMAN } from "../../../redux/constants/roles";
import SkeletonAvatar from "antd/es/skeleton/Avatar";
const { Search } = Input;

const TopHeader = () => {
  const [menuItems, setMenuItems] = useState(false);

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const isLogin = useSelector((state) => state.auth_store.is_Login);
  const role = useSelector((state) => state.auth_store.role);
  const authData = useSelector((state) => state.auth_store);
  // console.log("Authdata is:", authData);
  const items = [
    {
      key: 1,
      label: "Home",
      link: "/",
    },
    {
      key: 2,
      label: "About",
      link: "/about",
    },
  ];
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  const [location, setLocation] = useLocation();
  const myOrdersItems = [
    {
      key: "1",
      label: (
        <Link
          to="/orders"
          onClick={() => {
            setMenuItems(false);
          }}
        >
          Confirmed Orders
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          to="/order-requests"
          onClick={() => {
            setMenuItems(false);
          }}
        >
          Orders Requests
        </Link>
      ),
    },
  ];
  const avatarItems = [
    {
      key: "1",
      label: (
        <div>
          <p>{authData?.name}</p>
          <p className="text-gray-500">{authData?.email_or_mobile}</p>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          className="border-b border-t py-1 min-w-full"
          onClick={() => {
            setMenuItems(false);
          }}
        >
          <Link to="/myaccount" className="block">
            My Account
          </Link>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          className="bg-[#B91C1C] hover:shadow-md text-white border-0 font-semibold rounded-lg"
          onClick={() => {
            dispatch(logout());
            setLocation("/");
          }}
        >
          Log Out
        </Button>
      ),
    },
  ];
  return (
    <Header className="bg-white w-full h-auto max-sm:w-full max-sm:px-4 max-lg:px-0">
      <div className="flex justify-between w-full items-center sm:px-16 gap-4">
        <Link to="/" className="flex gap-4 max-h-full">
          <img
            src="/assets/alp.svg"
            className="w-[80px]"
            // preview={false}
            alt="ALP Logo"
          />
        </Link>
        {role !== DEALER && (
          <Row>
            <Search
              placeholder="Search..."
              onSearch={onSearch}
              style={{
                width: 300,
              }}
            />
          </Row>
        )}
        <nav className="flex items-center">
          <MenuOutlined
            className="sm:hidden"
            style={{ fontSize: "20px" }}
            onClick={() => {
              setMenuItems(true);
            }}
          />

          <div
            className={`max-sm:absolute top-0 right-0 z-10 max-sm:bg-white max-sm:h-screen max-sm:text-center transition-all ease-linear duration-500 ${
              menuItems
                ? "max-sm:w-[100vw] max-sm:p-8"
                : "max-sm:w-0 max-sm:p-0 overflow-hidden"
            }`}
          >
            <CloseSquareOutlined
              className={`sm:hidden text-[#000] float-end ${
                menuItems ? "null" : "hidden"
              }`}
              style={{ fontSize: "24px" }}
              onClick={() => {
                setMenuItems(false);
              }}
            />
            <ul className="sm:flex gap-8 items-center justify-center max-sm:text-left max-sm:w-max max-sm:mx-auto max-sm:p-8 font-semibold sm:text-[16px]">
              {role !== DEALER ? (
                <>
                  {items.map((item) => (
                    <li
                      className="text-[#000] leading-normal max-sm:my-8"
                      key={item.key}
                    >
                      <Link
                        to={item.link}
                        onClick={() => {
                          setMenuItems(false);
                        }}
                        className="hover:text-[#B91C1C]"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                  {/* <li className="text-[#000] leading-normal max-sm:my-8">
                    <Link
                      to=""
                      onClick={() => {
                        setOpen(true);
                      }}
                      className="hover:text-[#B91C1C]"
                    >
                      Categories{" "}
                      <DownOutlined className="text-[12px] mt-auto" />
                    </Link>
                    <Drawer
                      title="Categories"
                      onClose={() => {
                        setOpen(false);
                      }}
                      open={open}
                      placement="top"
                      className="bg-gradient-to-b from-[#FFFFFF] to-[#626365]/30 min-h-[60vh] max-sm:min-h-screen"
                    >
                      <div className="flex max-sm:flex-col items-center gap-8">
                        <div className="rounded-xl sm:w-1/3 text-center max-sm:h-[150px] max-sm:my-6">
                          <Link to="/category">
                            <Image
                              className="rounded-xl"
                              height="100%"
                              onClick={() => {
                                setOpen(false);
                              }}
                              src="/assets/categories/automotive.jpg"
                              preview={false}
                            />
                            <p className="text-xl">Automotive</p>
                          </Link>
                        </div>
                        <div className="rounded-xl sm:w-1/3 text-center max-sm:h-[150px] max-sm:my-6">
                          <Link to="/category">
                            <Image
                              className="rounded-xl"
                              height="100%"
                              onClick={() => {
                                setOpen(false);
                              }}
                              src="/assets/categories/sports.jpg"
                              preview={false}
                            />
                            <p className="text-xl">
                              Sports, Leisure & Flooring
                            </p>
                          </Link>
                        </div>
                        <div className="rounded-xl sm:w-1/3 text-center max-sm:h-[150px] max-sm:my-6">
                          <Link to="/category">
                            <Image
                              className="rounded-xl"
                              height="100%"
                              onClick={() => {
                                setOpen(false);
                              }}
                              src="/assets/categories/ac.jpg"
                              preview={false}
                            />
                            <p className="text-xl">AC & Refrigeration</p>
                          </Link>
                        </div>
                      </div>
                    </Drawer>
                  </li> */}
                  {!isLogin ? (
                    <>
                      <li>
                        <Link to="/login/dealer">
                          <Button className="bg-[#0474B8] hover:shadow-md text-white border-0 font-semibold rounded-lg">
                            Login as Dealer
                          </Button>
                        </Link>
                      </li>
                      <li>
                        <Link to="/login/retailer">
                          <Button className="bg-[#B91C1C] hover:shadow-md text-white border-0 font-semibold rounded-lg">
                            Login as Retailer
                          </Button>
                        </Link>
                      </li>
                    </>
                  ) : role === DEALER ? (
                    <>
                      {role !== SALESMAN && (
                        <li className="pe-2 flex items-center">
                          <Link to="/cart">
                            <Badge count={5} size="small">
                              <ShoppingCartOutlined className="text-lg font-medium" />
                            </Badge>
                          </Link>
                        </li>
                      )}

                      <li>
                        <Button
                          className="bg-[#B91C1C] hover:shadow-md text-white border-0 font-semibold rounded-lg"
                          onClick={() => {
                            dispatch(logout());
                            setLocation("/");
                          }}
                        >
                          Log Out
                        </Button>
                      </li>
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  <li>
                    <Link
                      to="/cart"
                      onClick={() => {
                        setMenuItems(false);
                      }}
                    >
                      <Button className="bg-[#B91C1C] hover:shadow-md max-sm:bg-transparent max-sm:text-black text-white border-0 font-semibold rounded-lg">
                        Cart
                      </Button>
                    </Link>
                  </li>
                  <li>
                    <Dropdown menu={{ items: myOrdersItems }}>
                      <Button className="bg-[#B91C1C] max-sm:bg-transparent max-sm:text-black hover:shadow-md text-white border-0 font-semibold rounded-lg">
                        My Orders <DownOutlined />
                      </Button>
                    </Dropdown>
                  </li>
                  <li>
                    <Link
                      to="/"
                      onClick={() => {
                        setMenuItems(false);
                      }}
                    >
                      <Button className="bg-[#0474B8] max-sm:bg-transparent max-sm:text-black hover:shadow-md text-white border-0 font-semibold rounded-lg">
                        Visit our E-Commerce Website
                      </Button>
                    </Link>
                  </li>
                  <li>
                    <Dropdown
                      menu={{ items: avatarItems }}
                      className="max-sm:hidden"
                    >
                      <Avatar className="max-sm:hidden">
                        <UserOutlined className="text-[#B91C1C]" />
                      </Avatar>
                    </Dropdown>
                    <Dropdown
                      menu={{ items: avatarItems }}
                      className="sm:hidden"
                    >
                      <Button className="sm:hidden bg-[#B91C1C] hover:shadow-md max-sm:bg-transparent max-sm:text-black text-white border-0 font-semibold rounded-lg">
                        Profile
                      </Button>
                    </Dropdown>
                  </li>
                </>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </Header>
  );
};

export default TopHeader;
